var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-button',{attrs:{"disabled":_vm.disabled,"full":"","color":"bt-facebook","icon":"Facebook","icon-size":26,"data-testid":"facebook-btn"},on:{"click":_vm.logInWithFacebook}},[_vm._v("Login with Facebook")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }